<template>
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
                v-model="searchForm.nursinghomeId"
                style="width:100%"
                placeholder="服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        
          <el-col :span="6">
            <el-form-item label="姓名" prop="name">
              <el-input
                clearable
                v-model="searchForm.name"
                placeholder="姓名"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          
         
         
  
         
          <el-col :span="12">
            <div style="float:right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
       
        <template slot="menuLeft">
            <el-button type="primary" v-if="permissionList.exportBtn" size="small" icon="el-icon-plus" @click="exportExcel()"
          >导 出
        </el-button>
        
        </template>
       
      </avue-crud>
     
    
    </basic-container>
  </template>
  <script>
  import { getNursinghomeList } from '../../api/public.js';
  import { bedalarmpage } from '@/api/nursingHome/security.js';

  import searchFromShow from '@/components/search-form-show/index';
  import { getDictionary } from '@/api/common.js';
  import { mapGetters } from 'vuex';
  import { getToken } from '@/util/auth';
  export default {
    components: { searchFromShow },
    data() {
      return {
       
        searchForm: {
          nursinghomeId: '',
          toCallName: '',
       
        },
       
        nursinghomeList: [],
  
        option: {
          selection: false,
          select: true,
          index: true,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '服务网点',
              prop: 'nursinghomeId',
              type: 'string',
            dataType: 'number',
            props: {
              label: 'name',
              value: 'id',
            },
            dicUrl: '/api/nursing/getNursinghome',
            },
           
            {
              label: '姓名',
              prop: 'name',
            },
           
            {
              label: '设备IMEI',
              prop: 'deviceSerial',
            },
            {
              label: '床垫名称',
              prop: 'bedName',
            },
            {
              label: '告警项',
              prop: 'alarmItem',
            },
            {
              label: '告警值',
              prop: 'alarmValue',
            },
            {
              label: '告警时间',
              prop: 'alarmTime',
            },
            {
              label: '紧急联系人',
              prop: 'emergencyContactName',
            },
            {
              label: '紧急联系人电话',
              prop: 'emergencyContactPhone',
            },
           
          ],
        },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
        exportForm:{}
      };
    },
    created() {
      
      this.initData();
    },
    computed: {
      ...mapGetters(['permission']),
    permissionList() {
      return {
        exportBtn: this.vaildData(this.permission.bedAlarm_export, false),
        
      };
    },
    },
    mounted() {
      this.calcHeight();
      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    activated() {
      // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
      this.$nextTick(() => {
        this.$refs.crud.refreshTable();
      });
    },
    methods: {
     exportExcel(){
        this.$confirm('是否导数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
      
        
          // 将条件参数拼接为路由传参格式
          let paramFormString = this.tool.objToform(this.exportForm);
          //
          this.tool.downloadFile(
            `/api/v4ward/nursing/bed/alarm/export?${
              this.website.tokenHeader
            }=${getToken()}&${paramFormString}`,
            'abc.xlsx',
            'xlsx/xls'
          );
        
      });
     },
    
      deleteFun(id){
        this.$confirm(' 是否删除该数据?', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
           }).then(() => {
            serviceItemRemove(id).then(re=>{
              this.$message.success('删除成功');
              this.onLoad()
            })
           
           }).catch(() => {
             this.$message({
               type: 'info',
               message: '已取消操作'
             });          
           });
       
      },

    
      nursinghomeIdChange(nursinghomeId) {
      
        this.searchForm.warehouseId =''
        this.warehouseList = [];
        getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
              this.warehouseList = res.data;
            });
        // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
        // //           this.canteenList = res.data
        // //        })
        // this.getDeptList(this.searchForm.nursinghomeId);
        // this.getCanteen(this.searchForm.nursinghomeId);
      },
      searchRecord() {
        this.page.currentPage = 1;
        if(this.searchForm.upWarnFlag==""){
          this.searchForm.upWarnFlag = false
        }
        if(this.searchForm.downWarnFlag==""){
          this.searchForm.downWarnFlag = false
        }
        this.onLoad();
      },
      searchClear() {
        this.tool.clearObject(this.searchForm, 'nursinghomeId');
        this.searchForm.type='0'
      },
  
      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },
      initData() {
        getDictionary('nursinghome_service_type').then((res) => {
            this.typeDice = res.data;
          });
        getNursinghomeList().then((res) => {
          
          this.nursinghomeList = res.data;
          if (this.nursinghomeList.length > 0) {
            this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeList[0].id);
           
            this.onLoad();
          }
        });
        // getDictionary('canteen_order_status').then((res) => {
        //   this.orderStatus = res.data;
        // });
      },
  
      onLoad() {
        if (this.searchForm.nursinghomeId != '') {
          this.loading = true;
            this.exportForm =this.searchForm
          bedalarmpage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }
  
  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #form > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
  